module.exports = __webpack_public_path__ + "img/center_ic_resume.217f47ba.png";